import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { switchMap, map } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';

import { AuthService, UserInfo } from '../../services/auth-service';
import { PendingOrderService } from '../../services/pending-order-service';
import { MenuComponent, MenuItem } from '../../components/shared/menu-component/menu-component';

@Component({
  selector: 'app-dashboard-component',
  standalone: true,
  imports: [
    CommonModule,
    MenuComponent
  ],
  templateUrl: './dashboard-component.html',
  styleUrls: ['./dashboard-component.scss']
})
export class DashboardComponent {
  menuItems$: Observable<MenuItem[]>;

  constructor(
    private authService: AuthService,
    private pendingOrderService: PendingOrderService
  ) {
    this.menuItems$ = combineLatest([
      this.authService.getCurrentUser(),
      this.pendingOrderService.getPendingOrders()
    ]).pipe(
      map(([userInfo, pendingOrders]) => {
        const isAuthenticated = !!userInfo;
        const pendingCount = pendingOrders.length;

        const menu: MenuItem[] = [
          { title: 'Login', icon: 'login', disabled: false, link: '/login', count: 0 },          
          { title: 'Sync', icon: 'sync', disabled: !isAuthenticated, link: '/sync', count: 0 },
          { title: 'Sales', icon: 'point_of_sale', disabled: !isAuthenticated, link: '/sales', count: 0 },
          {
            title: 'Pending Orders',
            icon: 'hourglass_empty',
            disabled: !isAuthenticated || pendingCount === 0,
            link: '/pending',
            count: isAuthenticated ? pendingCount : 0
          },
          {
            title: 'Sales Order Report',
            icon: 'assignment',
            disabled: !isAuthenticated,
            link: '/so-report',
            count: 0
          }
        ];

        if (userInfo) {
          if (userInfo.isLoadManager)
            menu.push({
              title: 'Load Management',
              icon: 'inventory_2',
              disabled: !isAuthenticated,
              link: '/load-management',
              count: 0
            });
            
          if (userInfo.isPacker)  
            menu.push({
              title: 'Packing',
              icon: 'archive',
              disabled: !isAuthenticated,
              link: '/pack-up',
              count: 0
            });

          if (userInfo.isDeliveryBoy)
            menu.push({
              title: 'Delivery',
              icon: 'local_shipping',
              disabled: !isAuthenticated,
              link: '/delivery-management',
              count: 0
            });

          if (userInfo.isDeliveryBoy)
            menu.push({
              title: 'Load Summary',
              icon: 'summarize',
              disabled: !isAuthenticated,
              link: '/load-summary',
              count: 0
            });       
        }

        return menu;
      })
    );
  }
}
